import React, { useCallback, useEffect, useState } from 'react'
import _cx from 'classnames/bind'
import PropTypes from 'prop-types'
import { ListingBadges, hooks, useApplicationContext } from '@adc/ui-adc'
import analytics, { eventNames } from 'common/services/analytics'
import {
  NOTIFY_RESERVE,
  TRANSIENT_MESSAGE_PROPERTY_SAVED_TITLE,
  TRANSIENT_MESSAGE_NOTIFY_RESERVE_BODY,
} from '../../statics'
import { usePropertyContext } from '../../context/property'
import { getApplicationNotificationsContext } from '../../utils/applicationNotificationsBridge'
import cls from './index.scss'

const cx = _cx.bind(cls)
const { useIsMobileHook } = hooks

const Badges = ({ listing, badgeActions }) => {
  const [badgesPerRow, setBadgesPerRow] = useState(null)
  const { property } = usePropertyContext()
  const { featureFlags } = useApplicationContext()

  const badgeEventSubscriber = useCallback(
    (ref, e) => {
      if (ref === 'contact_agent' || ref === 'interior_access_contact_agent') {
        badgeActions.toggleContactModal()
      }

      if (ref === 'emd_badge_expanded') {
        analytics.track({
          eventName: eventNames.pdpEmdBadgeExpanded,
          additionalFields: { listing_id: listing.listing_id },
        })
      }

      if (ref === 'notify_me') {
        // Check if property is already saved
        if (property.is_currently_saved) {
          // If already saved, just show the success banner without calling any save/unsave action
          const notifications = getApplicationNotificationsContext()
          notifications.overlayBanner.open({
            title: TRANSIENT_MESSAGE_PROPERTY_SAVED_TITLE,
            message: TRANSIENT_MESSAGE_NOTIFY_RESERVE_BODY,
          })
        } else {
          // If not saved, save it (toggleSaveProperty will save since is_currently_saved is false)
          badgeActions.toggleSaveProperty({
            source: NOTIFY_RESERVE,
          })
        }
      }
    },
    [badgeActions, property, listing.listing_id]
  )
  const isMobile = useIsMobileHook()

  useEffect(() => {
    setBadgesPerRow(isMobile ? 1 : 2)
  }, [isMobile])

  return (
    <div className={cx('badge-list')}>
      {badgesPerRow ? (
        <ListingBadges
          listing={listing}
          eventSubscriber={badgeEventSubscriber}
          badgesPerRow={badgesPerRow}
          featureFlags={featureFlags}
        />
      ) : null}
    </div>
  )
}

Badges.propTypes = {
  listing: PropTypes.object.isRequired,
  badgeActions: PropTypes.object.isRequired,
}

export default Badges
